/**
 * @module Experience / Repdash - back to top directive
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Directive, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';

@Directive({
  selector: '[tmoFormPdl]',
})

/**
 * Component for adding a go-to-top button to scrollable browser content
 */
export class FormPdlDirective extends PDLBaseComponent implements OnInit, OnDestroy {
  // tslint:disable-next-line:no-input-rename
  @Input('tmoFormPdl') public pdlPageComponentId: string = '';
  public formName: string;
  constructor(
    public activatedRoute: ActivatedRoute,
    private pdlWrapperService: PdlWrapperService,
    public pdlService: PdlService
  ) {
    super(pdlService, activatedRoute);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.formName = '';
  }

  /**
   * Called whenever a CTA is clicked
   * @param event - Event object
   * Emits an event with 'event' object as data.
   */
  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    const interval = 200;
    let counter = 0;
    if (this.pdlWrapperService.formStartNameArr.length > 0) {
      const limit = this.pdlWrapperService.formStartNameArr.length;
      const intervalRef = setInterval(() => {
        counter++;
        this.formName = this.pdlWrapperService.formStartNameArr[counter - 1];
        // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'formComplete');
        if (counter >= limit) {
          clearInterval(intervalRef);
          this.pdlWrapperService.formStartNameArr = [];
          counter = 0;
        }
      }, interval);
    }
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
